//
// This must be in a separate file because it's imported by busSources.ts, which is also used
// in the browser, so it must only import zod types.
// (Also, these types are used by both `linkPath` and `unlinkPath`.)
//
import { z } from 'zod/v4-mini';
import { matchingZodObject } from '../utilities/matchingZodObject.js';
const ZodPackageHashesEntry = z.object({
    browser: z.record(z.string(), z.string()),
    node: z.record(z.string(), z.string()),
});
const ZodLinkedPath = matchingZodObject({
    path: z.string(),
    rootPath: z.optional(z.string()),
    includeAll: z.optional(z.boolean()),
    ignoredPackages: z.optional(z.array(z.string())),
    ignoreResolutions: z.optional(z.union([z.boolean(), z.array(z.string())])),
    resolveStrategy: z.optional(z.literal(['dedupe', 'duplicate'])),
    remote: z.optional(matchingZodObject({
        hostUrl: z.string(),
        // Skip schema validation of the resolve map since it's likely very large, and the various
        // zod and procedure type helpers ensure the type is correct in the API.
        resolveMap: z.record(z.string(), z.any()),
        // Same with the serializable package definitions.
        // If we need to enforce usage/sharing of a minimal subset of properties, that should be done
        // with smaller subset/pick type (non-zod) which is used in all relevant locations.
        packages: z.object({
            definitions: z.record(z.string(), z.any()),
            transformedDefinitions: z.record(z.string(), z.any()),
        }),
        packageHashes: z.object({
            hashesWithSource: ZodPackageHashesEntry,
            hashesWithNoSource: ZodPackageHashesEntry,
        }),
    })),
});
export const ZodLinkPathInput = matchingZodObject({ linkedPath: ZodLinkedPath });
export const ZodLinkPathOutput = matchingZodObject({
    // Don't check the schema of the resolve map as it can be very large.
    resolveMap: z.record(z.string(), z.any()),
    linkedPaths: z.array(ZodLinkedPath),
});
//# sourceMappingURL=LinkPath.js.map